import { NavigationGuardNext } from 'vue-router';

import { AUTH_UI_MESSAGE, AUTH_UI_RESPONSE, IframeRedirectActions, IframeStatusMessages } from './constants';
import { ParentIframeEvent } from './types';

export const waitForIframeEvent = (): Promise<ParentIframeEvent | never> => {
  return new Promise((resolve) => {
    const handler = (event: MessageEvent) => {
      if (event.data.type === AUTH_UI_MESSAGE) {
        event.data.once && window.removeEventListener('message', handler);
        resolve(event.data);
      }
    };

    window.addEventListener('message', handler);
  });
};

export const validateIframeActions = (action: unknown): action is IframeRedirectActions => {
  return typeof action === 'string' && action in IframeRedirectActions;
};

export const sendIframeResponseEvent = (status: IframeStatusMessages) => {
  if (status === IframeStatusMessages.InvalidAction) {
    window.parent.postMessage({
      type: AUTH_UI_RESPONSE,
      status: IframeStatusMessages.InvalidAction,
    }, '*');
    throw new Error (IframeStatusMessages.InvalidAction);
  }
  window.parent.postMessage({
    type: AUTH_UI_RESPONSE,
    status: IframeStatusMessages.Success,
  }, '*');
};

export const processIframeEvents = (action: IframeRedirectActions): boolean | string | NavigationGuardNext | void => {
  switch (action) {
    case IframeRedirectActions.PaymentsRedirect:
      sendIframeResponseEvent(IframeStatusMessages.Success);
      return '/account/payments';
    default:
      sendIframeResponseEvent(IframeStatusMessages.InvalidAction);
  }
};
